import { AddDigitalWalletComponent } from '@3ddv/software-division-components';
import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { PatronModel } from '@core/models/patron.model';
import { BraintreePayload } from '@features/pages/payment/components/braintree/types';
import { ConnectionService } from '@features/pages/payment/services/connection.service';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';

@Component({
  standalone: true,
  selector: 'app-add-digital-wallet-modal',
  templateUrl: './add-digital-wallet-modal.component.html',
  styleUrls: ['./add-digital-wallet-modal.component.css'],
  imports: [AddDigitalWalletComponent],
})
export class AddDigitalWalletModalComponent implements OnInit, OnDestroy {
  patron: PatronModel;
  acceptFunc: (digitalWalletList: PatronModel['digitalWalletList']) => void;

  braintreeToken: string;
  errorMessage: string | null = null;
  isLoading = false;
  isDefaultCard = false;
  subscriptions: Subscription[] = [];

  bsModalRef = inject(BsModalRef);
  private connectionService = inject(ConnectionService);

  ngOnInit(): void {
    this.initComponent();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  private initComponent(): void {
    this.isLoading = true;

    const subscription = this.connectionService.getAddCardToken().subscribe({
      next: response => {
        if (response.data?.btToken) {
          this.braintreeToken = response.data.btToken;
        }
      },
      error: error => {
        console.log(error);
        this.errorMessage = error.message;
      },
      complete: () => {
        this.isLoading = false;
      },
    });

    this.subscriptions.push(subscription);
  }

  setUseDefaultCard(value: boolean) {
    console.log('SET DEFAULT ', value);
    this.isDefaultCard = value;
  }

  accept(data: BraintreePayload) {
    console.log('ACCEPT', data);

    this.isLoading = true;

    const subscription = this.connectionService
      .addPatronCardToDigitalWallet({
        patronId: this.patron.patronProvenueId,
        paymentNonce: data.nonce,
        useAsDefaultCard: this.isDefaultCard,
      })
      .subscribe({
        next: response => {
          if (
            Array.isArray(response.data?.digitalWalletList) &&
            response.data?.digitalWalletList.length > 0
          ) {
            this.acceptFunc(response.data.digitalWalletList);
            this.bsModalRef.hide();
          }
        },
        error: error => {
          console.log(error);
          this.errorMessage = error.message;
        },
        complete: () => {
          this.isLoading = false;
        },
      });

    this.subscriptions.push(subscription);
  }

  close() {
    console.log('CLOSE');
    this.bsModalRef.hide();
  }
}
